// Module
var code = "<md-select ng-model=\"vm.search\" placeholder=\"{{ 'search' | translate }}\" md-on-open=\"vm.getItems()\"\n           class=\"md-table-select\" md-container-class=\"md-table-select\" multiple=\"false\"\n           ng-change=\"vm.change()\">\n    <md-option ng-repeat=\"item in vm.items track by $index\"></md-option>\n</md-select>";
// Exports
module.exports = code;